export default {
	title: "Centrum Osobiste",
	subTitle: ["Profil", "Bezpieczeństwo", "System"],
	menu: ["Zmień dane osobowe", "Nazwa użytkownika", "Zaktualizuj hasło", "Zaktualizuj hasło transakcji"],
	updatePassword: {
		form: {
			label: ["Stare hasło", "Nowe hasło", "Potwierdź nowe hasło"]
		}
	},
	updateTransactionPassword: {
		form: {
			label: ["Stare hasło", "Nowe hasło", "Potwierdź nowe hasło"]
		}
	}
};
